// src/hooks/useMediaQuery.js
import { useState, useEffect } from 'react';

/**
 * Subscribe to a CSS media query and return whether it currently matches.
 *
 * Used to render a single layout branch instead of hiding one with CSS:
 * a `display:none` branch still downloads its `loading="lazy"` images in
 * Chrome, so mounting only the active branch avoids duplicate image loads.
 */
const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    setMatches(mql.matches); // sync in case the query changed between renders
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

export default useMediaQuery;
